//Cookie keys
export const ACCOUNT_TYPE_COOKIE = "ACCOUNT_TYPE_COOKIE";
export const KYC_STATUS_COOKIE = "KYC_STATUS_COOKIE";
export const USER_ROLE_COOKIE = "USER_ROLE_COOKIE";
export const IS_STRIPE_COOKIE = "IS_STRIPE_COOKIE";
export const ATK_COOKIE = "ATK_COOKIE";
export const COOKIE_KEY = "frythub_cookie";
export const COOKIEISLOGGEDIN = "isLoggedIn";

//todos: replace all hardcoded string with a global constants
export const LOCAL_STORAGE_ACCESS_TOKEN = "token";
export const LOCAL_STORAGE_TOKEN_EXPIRY = "frythub_TExpiry";
export const LOCAL_STORAGE_REFRESH_TOKEN = "refresh_token";
export const LOCAL_STORAGE_USER_TYPE = "user_type";
export const LOCAL_STORAGE_KYC_VALUE = "vague";
export const LOCAL_STORAGE_USER_DATA = "frythub_userD";

import { stripProtocol } from "../functions/stripProtocol";

export const userType = {
  agent: "Agent",
  shipping: "Shipping",
  User: "User",
};
export enum USER_TYPE_ENUM {
  user = 1,
  deliveryAgent = 2,
  buyingAgent = 3,
  shippingAgent = 4,
}

export enum KycStatusType {
  NOT_CAPTURED = "1",
  DENIED = "2",
  PROCESSING = "3",
  APPROVED = "4",
}
export enum AgentAccountType {
  DELIVERY = "1",
  BUYING_DELIVERY = "2",
}

export const cloudinaryBaseUrl = ({
  cloudName,
  apiKey,
  timeStamp,
  signature,
}: {
  cloudName: string;
  apiKey: string;
  timeStamp: string;
  signature: string;
}) =>
  `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload?api_key=${apiKey}&timestamp=${timeStamp}&signature=${signature}`;

//API SERVICE FOR CORE
export const apiBaseUrl =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_PRODBASE
    : process.env.NEXT_PUBLIC_PRODBASE;

//API SERVICE FOR STRAPI BACKEND
export const strapiBaseUrl =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_STRAPI_URL
    : process.env.NEXT_PUBLIC_STRAPI_URL;

//Strapi token
export const strapiApiToken =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_STRAPI_API_TOKEN
    : process.env.NEXT_PUBLIC_STRAPI_API_TOKEN;

//API SERVICE FOR NOTIFICATION
export const notificationApiBaseUrl =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_PROD_NOTIFICATION
    : process.env.NEXT_PUBLIC_PROD_NOTIFICATION;

//Freshwork api Base
export const freshWorkApiBaseUrl =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_FRESHWORK_API_BASE_PROD
    : process.env.NEXT_PUBLIC_FRESHWORK_API_BASE_PROD;

export const freshWorkToken =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_FRESHWORK_TOKEN_PROD
    : process.env.NEXT_PUBLIC_FRESHWORK_TOKEN_PROD;

//cloudinary keys
export const cloudName =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_CLOUDINARY_NAME_DEV
    : process.env.NEXT_PUBLIC_CLOUDINARY_PROD_NAME;

export const apiKey =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APIKEY
    : process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APIKEY;

export const apiSecret =
  process.env.NODE_ENV === "development"
    ? process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APISECRET
    : process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APISECRET;

//Sentry
export const sentryDSN =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_SENTRY_DSN
    : process.env.NEXT_PUBLIC_SENTRY_DSN;

//google keys
export const googleClientId =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID
    : process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

export const googleMapKey =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_GOOGLE_MAP_API
    : process.env.NEXT_PUBLIC_GOOGLE_MAP_API;

export const placeholderBlurhash =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAoJJREFUWEfFl4lu4zAMRO3cx/9/au6reMaOdkxTTl0grQFCRoqaT+SQotq2bV9N8rRt28xms87m83l553eZ/9vr9Wpkz+ezkT0ej+6dv1X81AFw7M4FBACPVn2c1Z3zLgDeJwHgeLFYdAARYioAEAKJEG2WAjl3gCwNYymQQ9b7/V4spmIAwO6Wy2VnAMikBWlDURBELf8CuN1uHQSrPwMAHK5WqwFELQ01AIXdAa7XawfAb3p6AOwK5+v1ugAoEq4FRSFLgavfQ49jAGQpAE5wjgGCeRrGdBArwHOPcwFcLpcGU1X0IsBuN5tNgYhaiFFwHTiAwq8I+O5xfj6fOz38K+X/fYAdb7fbAgFAjIJ6Aav3AYlQ6nfnDoDz0+lUxNiLALvf7XaDNGQ6GANQBKR85V27B4D3QQRw7hGIYlQKWGM79hSweyCUe1blXhEAogfABwHAXAcqSYkxCtHLUK3XBajSc4Dj8dilAeiSAgD2+30BAEKV4GKcAuDqB4TdYwBgPQByCgApUBoE4EJUGvxUjF3Q69/zLw3g/HA45ABKgdIQu+JPIyDnisCfAxAFNFM0EFNQ64gfS0EUoQP8ighrZSjn3oziZEQpauyKbfjbZchHUL/3AS/Dd30gAkxuRACgfO+EWQW8qwI1o+wseNuKcQiESjALvwNoMI0TcRzD4lFcPYwIM+JTF5x6HOs8yI7jeB5oKhpMRFH9UwaSCDB2Jmg4rc6E2TT0biIaG0rQhNqyhpHBcayTTSXH6vcDL7/sdqRK8LkwTsU499E8vRcAojHcZ4AxABdilgrp4lsXk8oVqgwh7+6H3phqd8J0Kk4vbx/+sZqCD/vNLya/5dT9fAH8g1WdNGgwbQAAAABJRU5ErkJggg==";
export const noCarImage =
  "https://res.cloudinary.com/adeyemicloud/image/upload/v1695003874/frythub/VehicleImageNotFound_sxm7vz.svg";
export const appDomain =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_DOMAIN_APP
    : process.env.NEXT_PUBLIC_DOMAIN_APP;

export const webDomain =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_DOMAIN_LANDING_URL
    : process.env.NEXT_PUBLIC_DOMAIN_LANDING_URL;

/**
 * Dynamic link to switch to sub domain
 * @param subdomain e.g app or checkout etc.
 * @param path  e.g /login or /dashboard e.tc
 * @returns
 */
export const dynamicUrl = (subdomain: string, path: string) =>
  process.env.NODE_ENV === "production"
    ? `https://${subdomain}.${webDomain}/${path}`
    : `https://${subdomain}.${stripProtocol(webDomain as string)}/${path}`;

/**
 * Different sub domain object
 * Allows us have a central place to change things.
 * @param app
 * @param checkout
 * @param base This is use to navigate home i.e http://localhost:3000 or domain.com
 * @returns
 */
export const subDomainType = {
  checkout:
    process.env.NODE_ENV === "production"
      ? process.env.NEXT_PUBLIC_CHECKOUT_SUB_DOMAIN
      : "checkout",
  app:
    process.env.NODE_ENV === "production"
      ? process.env.NEXT_PUBLIC_APP_SUB_DOMAIN
      : "app",
  base: webDomain,
};
